import { render, staticRenderFns } from "./DeclarationMarche.vue?vue&type=template&id=40dea164"
import script from "./DeclarationMarche.vue?vue&type=script&lang=js"
export * from "./DeclarationMarche.vue?vue&type=script&lang=js"
import style0 from "./DeclarationMarche.vue?vue&type=style&index=0&id=40dea164&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports